export function checkMainNet(type) {
  return type === 'MAINNET';
}
